<template>
	<div class="row my-6">
		<div class="col-12">

			<div v-if="error=='403'" class="bg-corporate">
				<div class="row content content-full bg-body-extra-light">
					<div class="col-12 justify-content-center mt-5">
						<!-- Header -->
					    <div class="py-4 px-1 text-center mb-4">
					     <h1 class="display-1 fw-bold text-corporate">
					        <i class="fa fa-ban me-1"></i>
					        <span>403</span>
					     </h1>
					      <h1 class="h2 fw-bold mt-5 mb-2">Access to This Page is Forbidden</h1>
					      <h2 v-if="message!=undefined" class="h4 fw-medium text-muted mb-0">We are sorry but you do not have permission to access this page..</h2>
					      <h2 v-else class="h4 fw-medium text-muted mb-0">We are sorry but you do not have permission to access this page..</h2>
					    </div>
					    <!-- END Header -->
					</div>
				</div>
			</div>

			<div v-else-if="error=='500'" class="bg-corporate">
				<div class="row content content-full bg-body-extra-light">
					<div class="col-12 justify-content-center mt-5">
						<!-- Header -->
					    <div class="py-4 px-1 text-center mb-4">
					     <h1 class="display-1 fw-bold text-corporate">
					        <i class="fa fa-times-circle me-1"></i>
					        <span>500</span>
					     </h1>
					      <h1 class="h2 fw-bold mt-5 mb-2">Server Encountered an Internal Error</h1>
					      <h2 v-if="message!=undefined" class="h4 fw-medium text-muted mb-0">We are sorry but your request contains bad syntax and cannot be fulfilled..</h2>
					      <h2 v-else class="h4 fw-medium text-muted mb-0">We are sorry but your request contains bad syntax and cannot be fulfilled..</h2>
					    </div>
					    <!-- END Header -->
					</div>
				</div>
			</div>


			<div v-else-if="error=='503'" class="bg-danger">
				<div class="row content content-full bg-body-extra-light">
					<div class="col-12 justify-content-center mt-5">
						<!-- Header -->
					    <div class="py-4 px-1 text-center mb-4">
					     <h1 class="display-1 fw-bold text-danger">
					        <i class="fa fa-cogs me-1"></i>
					        <span>503</span>
					     </h1>
					      <h1 class="h2 fw-bold mt-5 mb-2">Site Temporarily Down for Maintenance</h1>
					      <h2 v-if="message!=undefined" class="h4 fw-medium text-muted mb-0">Sorry, our site is temporarily unavailable for essential maintenance. Please try again shortly..</h2>
					      <h2 v-else class="h4 fw-medium text-muted mb-0">Sorry, our site is temporarily unavailable for essential maintenance. Please try again shortly..</h2>
					    </div>
					    <!-- END Header -->
					</div>
				</div>
			</div>

			<div v-else class="bg-danger">
				<div class="row content content-full bg-body-extra-light">
					<div class="col-12 justify-content-center mt-5">
						<!-- Header -->
					    <div class="py-4 px-1 text-center mb-4">
					     <h1 class="display-1 fw-bold text-danger">
					        <i class="fa fa-exclamation-triangle me-1"></i>
					        <span>404</span>
					     </h1>
					      <h1 class="h2 fw-bold mt-5 mb-2">Requested Page Cannot Be Found</h1>
					      <h2 v-if="message!=undefined" class="h4 fw-medium text-muted mb-0">We are sorry but the page you are looking for was not found.</h2>
					      <h2 v-else class="h4 fw-medium text-muted mb-0">We are sorry but the page you are looking for was not found.</h2>
					    </div>
					    <!-- END Header -->
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	
	export default{
		props:{
			error: String,
			message: String,
		},
		setup(props){

		}
	}
</script>